import api from './api';

export async function saveAudio(blob, name, AtendimentoId, DataGravacao, isTrueMP3 = false) {
    const form = new FormData();
    form.append('AtendimentoId', AtendimentoId);
    form.append('name', name);
    form.append('DataGravacao', DataGravacao);
    form.append('file', blob);
    form.append('trueMP3', isTrueMP3);
    console.log('===========POST AUDIO=======================');
    console.log(form);
    try {
        const result = await api.post('/Audio', form);
        console.log('===========RESPONSE POST AUDIO=======================');
        console.log(result);
        return result;
    } catch (error) {
        console.log('===========RESPONSE POST AUDIO=======================');
        console.error(error);
        return error;
    }
}

export async function saveAudioSalad(blob, name, AtendimentoId, DataGravacao, isTrueMP3 = false) {
    const form = new FormData();
    form.append('AtendimentoId', AtendimentoId);
    form.append('name', name);
    form.append('DataGravacao', DataGravacao);
    form.append('file', blob);
    form.append('trueMP3', isTrueMP3);
    console.log('===========POST AUDIO=======================');
    console.log(form);
    try {
        const result = await api.post('/Audio/salad', form);
        console.log('===========RESPONSE POST AUDIO=======================');
        console.log(result);
        return result;
    } catch (error) {
        console.log('===========RESPONSE POST AUDIO=======================');
        console.error(error);
        return error;
    }
}

export async function saveAudioV3(blob, name, AtendimentoId, DataGravacao, isTrueMP3 = false) {
    const form = new FormData();
    form.append('AtendimentoId', AtendimentoId);
    form.append('name', name);
    form.append('DataGravacao', DataGravacao);
    form.append('file', blob);
    form.append('trueMP3', isTrueMP3);
    console.log('===========POST AUDIO=======================');
    console.log(form);
    try {
        const result = await api.post('/Audio/speechTTAlternativo3', form);
        console.log('===========RESPONSE POST AUDIO=======================');
        console.log(result);
        return result;
    } catch (error) {
        console.log('===========RESPONSE POST AUDIO=======================');
        console.error(error);
        return error;
    }
}

export async function enviaTesteAudio(blob, name) {
    const form = new FormData();
    form.append('name', name);
    form.append('file', blob);
    const result = await api.post('/Audio/testeAudio', form);
    return result.data;
}

export async function transcribeLemonfoxOnly(blob, name) {
    const form = new FormData();
    form.append('file', blob);
    form.append('name', name); // Adiciona o nome ao FormData
    console.log('===========POST AUDIO transcribeLemonfoxOnly=======================');
    console.log(form);
    try {
        const result = await api.post('/Audio/transcribeLemonfoxOnly', form);
        console.log('===========RESPONSE POST AUDIO transcribeLemonfoxOnly=======================');
        console.log(result);
        return result.data.transcription; // Geralmente a transcrição está em result.data
    } catch (error) {
        console.log('===========RESPONSE POST AUDIO transcribeLemonfoxOnly=======================');
        console.error(error);
        return error; // Ou lançar o erro para ser tratado pelo chamador
    }
}
